import { Button, createButton } from '@vfde-brix/ws10/button';
import { HtmlId } from '../enum';
import { ResultCardConfig } from '../interface';
import { mountComponent } from '../util/mount';
import { getUrl } from '../util/url';

/**
 * Create Brix button component.
 * @param wrapperId ID of the button element.
 * @param callback OnClick event.
 */
export const mountButton = (wrapperId: HtmlId, callback?: Function) =>
    mountComponent(wrapperId, createButton, {
        onClick: (e: Event) => {
            e.preventDefault();
            callback?.();
        },
    });

export const updateResultButton = (comp: Button | null, productId?: string, config?: ResultCardConfig) => {
    const queryData = { product: productId, icmp: config?.icmp };

    comp?.update({
        linkHref: getUrl(config?.link, undefined, queryData),
        stdContent: config?.button,
        business: undefined,
    });
    comp?.toggleContainer(!config?.button);
};

export const updateButtonState = (comp: Button | null, isDisabled: boolean) =>
    comp?.update({ optDisabled: isDisabled });
